// Icons nach GL-023 §9.12: inline Stroke-SVG, 24er-Raster, runde Enden, currentColor.
// Pfade 1:1 aus den Canvas-Screens R3-T1 und R4/R5.
import type { ReactElement } from 'react';

const pfade = {
  start: <path d="M3.5 10.5 12 3.5l8.5 7V20a1 1 0 0 1-1 1H15v-6H9v6H4.5a1 1 0 0 1-1-1z" />,
  entdecken: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m15.5 8.5-2 5-5 2 2-5z" />
    </>
  ),
  rezepte: (
    <>
      <path d="M5 19.5V5.5A2.5 2.5 0 0 1 7.5 3H19v14H7.5A2.5 2.5 0 0 0 5 19.5 2.5 2.5 0 0 0 7.5 22H19" />
      <path d="M9 7.5h6" />
    </>
  ),
  woche: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </>
  ),
  einkaufen: (
    <>
      <path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8z" />
      <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
    </>
  ),
  nora: (
    <>
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
      <path d="M19 16.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z" />
    </>
  ),
  filter: (
    <>
      <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
      <circle cx="15" cy="7" r="2" />
      <circle cx="9" cy="17" r="2" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  suche: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-4.3-4.3" />
    </>
  ),
  kamera: (
    <>
      <path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2.3l1.5-2.2h5.4L16.2 7h2.3A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z" />
      <circle cx="12" cy="12.8" r="3.5" />
    </>
  ),
  bild: (
    <>
      <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
      <circle cx="9" cy="10" r="1.8" />
      <path d="m20.5 16-4.5-4.5L6 19.5" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
      <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
    </>
  ),
  gluehbirne: (
    <>
      <path d="M9 18h6M10 21h4" />
      <path d="M12 3a6 6 0 0 0-3.5 10.9c.6.4 1 1.1 1 1.9V16h5v-.2c0-.8.4-1.5 1-1.9A6 6 0 0 0 12 3z" />
    </>
  ),
  fehlerKreis: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5v5.5" />
      <path d="M12 16.3v.1" />
    </>
  ),
  nochmal: (
    <>
      <path d="M20 11a8 8 0 1 0-2.3 5.7" />
      <path d="M20 5v6h-6" />
    </>
  ),
  chevronRechts: <path d="m9 5 7 7-7 7" />,
  chevronLinks: <path d="m15 5-7 7 7 7" />,
  schliessen: <path d="M6 6l12 12M18 6 6 18" />,
  haken: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  ausrufezeichen: <path d="M12 6v8M12 18h.01" />,
  liste: (
    <>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <path d="M4.5 6h.01M4.5 12h.01M4.5 18h.01" />
    </>
  ),
  raster: (
    <>
      <rect x="4" y="4" width="6.5" height="6.5" rx="1.5" />
      <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5" />
      <rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5" />
    </>
  ),
  warnung: (
    <>
      <path d="M12 4 2.8 19.5h18.4z" />
      <path d="M12 10v4.5M12 17.2h.01" />
    </>
  ),
  abmelden: (
    <>
      <path d="M14 4h4.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H14" />
      <path d="M10 8l-4 4 4 4M6 12h10" />
    </>
  ),
  herz: <path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z" />,
  merken: <path d="M6.5 3.5h11v17l-5.5-4-5.5 4z" />,
  teilen: (
    <>
      <path d="M12 3v12M7.5 7.5 12 3l4.5 4.5" />
      <path d="M5 12v7.5A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V12" />
    </>
  ),
  kochen: (
    <>
      <path d="M4 11h16v2a6 6 0 0 1-6 6h-4a6 6 0 0 1-6-6z" />
      <path d="M2.5 11h19M9 7c0-1 1-1.5 1-2.5M13.5 7c0-1 1-1.5 1-2.5" />
    </>
  ),
  wochePlus: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4M12 13v5M9.5 15.5h5" />
    </>
  ),
  einkaufenPlus: (
    <>
      <path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8z" />
      <path d="M9 8V6.5a3 3 0 0 1 6 0V8M12 11.5v5M9.5 14h5" />
    </>
  ),
  blatt: (
    <>
      <path d="M5 19c0-8 5-14 15-14 0 10-6 15-14 15" />
      <path d="M5 19c3-4 6-6.5 9-8" />
    </>
  ),
  minus: <path d="M5 12h14" />,
  chevronUnten: <path d="m6 9 6 6 6-6" />,
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5.5M12 7.8h.01" />
    </>
  ),
  stift: <path d="M4 20h4L19 9a2.1 2.1 0 0 0-4-4L4 16z" />,
  muell: (
    <>
      <path d="M4.5 7h15M10 4h4M6.5 7l.9 12a1.5 1.5 0 0 0 1.5 1.4h6.2a1.5 1.5 0 0 0 1.5-1.4l.9-12" />
      <path d="M10 11v6M14 11v6" />
    </>
  ),
  kollektion: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M12 8.5v7M8.5 12h7" />
    </>
  ),
  mealprep: (
    <>
      <rect x="3.5" y="8" width="17" height="11" rx="2.5" />
      <path d="M3.5 12h17M8 8V5.5h8V8" />
    </>
  ),
  uhr: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  flamme: <path d="M12 3c1 3.5 5 5.5 5 10a5 5 0 0 1-10 0c0-2.2 1.1-3.8 2.3-5 .3 1.6 1.2 2.6 2.2 3 .2-3.2-.6-5.6.5-8z" />,
  glas: (
    <>
      <path d="M7 4h10l-1 16H8z" />
      <path d="M7.5 9h9" />
    </>
  ),
  tauschen: (
    <>
      <path d="M4 8h14l-3.5-3.5" />
      <path d="M20 16H6l3.5 3.5" />
    </>
  ),
  chevronOben: <path d="m6 15 6-6 6 6" />,
  pinsel: (
    <>
      <path d="M14.5 4.5 19.5 9.5 11 18l-5-5z" />
      <path d="M6 13c-2 .5-2.5 2.5-2.5 4.5 0 1.2-.5 2-1 2.5 2.5.5 6 0 7.5-2.5" />
    </>
  ),
  pfeilHoch: <path d="M12 19V5M6 11l6-6 6 6" />,
  // Canvas R4-Nora-Chat: "Anderen Vorschlag zeigen"
  aktualisieren: (
    <>
      <path d="M20 11a8 8 0 1 0-2.3 5.7" />
      <path d="M20 5v6h-6" />
    </>
  ),
  pfeilRunter: <path d="M12 5v14M6 13l6 6 6-6" />,
  // W8 Kochmodus und Was Nora ueber euch weiss (Pfade aus Lyras design-w8)
  stoppuhr: (
    <>
      <circle cx="12" cy="13.5" r="7.5" />
      <path d="M12 9.5v4l2.5 1.5M9.5 2.5h5M12 2.5V6" />
    </>
  ),
  glocke: (
    <>
      <path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15z" />
      <path d="M10 21h4" />
    </>
  ),
  glockeKlingelt: (
    <>
      <path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15z" />
      <path d="M10 21h4M3 7.5a9 9 0 0 1 2.5-3.5M21 7.5A9 9 0 0 0 18.5 4" />
    </>
  ),
  handyAn: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="2.5" />
      <path d="M11 18h2M3.5 8.5v7M20.5 8.5v7" />
    </>
  ),
  pause: <path d="M9 5.5v13M15 5.5v13" />,
  stopp: <rect x="6.5" y="6.5" width="11" height="11" rx="2" />,
  lautsprecher: (
    <>
      <path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" />
      <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" />
    </>
  ),
  wischen: <path d="M8 8l-4 4 4 4M16 8l4 4-4 4M4 12h16" />,
  play: <path d="M8 5.5v13l10.5-6.5z" />,
  verbot: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6 6l12 12" />
    </>
  ),
  regeln: (
    <>
      <path d="M10 6.5h10M10 12h10M10 17.5h10" />
      <path d="M3.5 6.5l1.5 1.5 2.5-3M3.5 12l1.5 1.5 2.5-3M3.5 17.5l1.5 1.5 2.5-3" />
    </>
  ),
  sanduhr: <path d="M7 3.5h10M7 20.5h10M8 3.5v2a4 4 0 0 0 1.6 3.2L12 10.5l2.4-1.8A4 4 0 0 0 16 5.5v-2M8 20.5v-2a4 4 0 0 1 1.6-3.2L12 13.5l2.4 1.8a4 4 0 0 1 1.6 3.2v2" />,
  person: (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c.8-3.6 3.6-5.5 7-5.5s6.2 1.9 7 5.5" />
    </>
  ),
  zurueckPool: (
    <>
      <path d="M9 14 4 9l5-5" />
      <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
    </>
  ),
  // Mein Tag (GL-023 1.6.0 §9.8): Besteck fuer Tab, Kochmodus-Block und Kachel "Gegessen"; eine Funktion, ein Symbol
  besteck: (
    <>
      <path d="M7 3v8M5 3v5a2 2 0 0 0 4 0V3M7 11v10" />
      <path d="M17 21V3c-2 1.5-3 4-3 7v3h3" />
    </>
  ),
  paket: (
    <>
      <path d="M12 3.5 20 7.5v9L12 20.5 4 16.5v-9z" />
      <path d="M4 7.5l8 4 8-4M12 11.5v9" />
    </>
  ),
  barcode: <path d="M4 5v14M7 5v14M10 5v14M12.5 5v14M15 5v14M18 5v14M20 5v14" />,
  schloss: (
    <>
      <rect x="5" y="10.5" width="14" height="10" rx="2" />
      <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    </>
  ),
  regler: (
    <>
      <path d="M4 7.5h9M17 7.5h3M4 16.5h3M11 16.5h9" />
      <circle cx="15" cy="7.5" r="2" />
      <circle cx="9" cy="16.5" r="2" />
    </>
  ),
} satisfies Record<string, ReactElement>;

export type IconName = keyof typeof pfade;

interface IconProps {
  name: IconName;
  // 14: Haken in kleinen Statuspunkten, 28/44: Statuskreise im Import (Canvas R4-Import-3, Wartescreen)
  groesse?: 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 44;
  strich?: number;
  className?: string;
  /** Flaeche fuellen (z. B. Merken aktiv) */
  gefuellt?: boolean;
}

/** Dekoratives Icon. Bedeutung traegt immer der umgebende Text oder ein aria-label. */
export function Icon({ name, groesse = 24, strich = 1.8, className, gefuellt = false }: IconProps) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill={gefuellt ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strich}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      {pfade[name]}
    </svg>
  );
}

/** Drei-Punkte-Menue, gefuellt (GL-023 §9.3). */
export function IconMehr({ groesse = 20 }: { groesse?: 20 | 22 }) {
  return (
    <svg width={groesse} height={groesse} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      <circle cx="12" cy="5.5" r="1.7" />
      <circle cx="12" cy="12" r="1.7" />
      <circle cx="12" cy="18.5" r="1.7" />
    </svg>
  );
}
